// extracted by mini-css-extract-plugin
export default {"backside":"CardBack-module--backside--g2ehJ"};